import React, {FC} from 'react';
import classNames from 'classnames';
import {useCtxConfig} from 'pages/dashboard/components/FirstLook/context';

import {BurstingBubbles} from './BurstingBubbles';
import {CircleConveyor} from './CircleConveyor';
import {CircularOrbits} from './CircularOrbits';
import {DriftingBubbles} from './DriftingBubbles';
import {FastBubbles} from './FastBubbles';
import {PopcornCircles} from './PopcornCircles';
import {RapidRebounds} from './RapidRebounds';
import {RicochetsAndRings} from './RicochetsAndRings';
import {SlowPulse} from './SlowPulse';
import {SoftPendulums} from './SoftPendulums';

import * as styles from './styles.module.scss';

interface BackgroundProps {
	className?: string
}

const Animation: FC = () => {
	const {screen} = useCtxConfig();
	switch (screen?.bg) {
	case 'bursting-bubbles':
		return <BurstingBubbles />;
	case 'circle-conveyor':
		return <CircleConveyor />;
	case 'circular-orbits':
		return <CircularOrbits />;
	case 'drifting-bubbles':
		return <DriftingBubbles />;
	case 'fast-bubbles':
		return <FastBubbles />;
	case 'popcorn-circles':
		return <PopcornCircles />;
	case 'rapid-rebounds':
		return <RapidRebounds />;
	case 'ricochets-and-rings':
		return <RicochetsAndRings />;
	case 'slow-pulse':
		return <SlowPulse />;
	case 'soft-pendulums':
		return <SoftPendulums />;
	};
};

export const Background: FC<BackgroundProps> = ({className}) => (
	<div className={classNames(styles.background, className)}>
		<Animation />
	</div>
);
